import { render } from "./Err404.vue?vue&type=template&id=98ffe0b6"
import script from "./Err404.vue?vue&type=script&lang=js"
export * from "./Err404.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__